
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/Euler/HiLoadPV",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/Euler/HiLoadPV/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/Euler/HiLoadPV"])
      });
    }
  